// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map-overlay {
  position: absolute;
  top: var(--header-height);
  left: 380px;
  bottom: 0;
  right: 0;
  pointer-events: none;
}
.map-overlay .map-blocker {
  height: 100%;
  width: 100%;
  pointer-events: initial;
  background-color: rgba(34, 34, 34, 0.3);
}
.map-overlay map-search-bar, .map-overlay select-tour-type, .map-overlay toggle-map-style, .map-overlay waypoint-help {
  position: absolute;
}
.map-overlay map-search-bar, .map-overlay toggle-map-style, .map-overlay waypoint-help {
  pointer-events: initial;
}
.map-overlay toggle-map-style {
  bottom: var(--element-spacing);
  right: var(--element-spacing);
}
.map-overlay select-tour-type {
  top: var(--element-spacing);
  right: var(--element-spacing);
}
.map-overlay map-search-bar {
  top: var(--element-spacing);
  left: var(--element-spacing);
}
.map-overlay waypoint-help {
  top: calc(var(--element-spacing) + 60px + var(--element-spacing));
  right: var(--element-spacing);
}`, "",{"version":3,"sources":["webpack://./src/app/components/map-overlay/map-overlay.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,oBAAA;AACJ;AACI;EACI,YAAA;EACA,WAAA;EACA,uBAAA;EACA,uCAAA;AACR;AAEI;EACI,kBAAA;AAAR;AAGI;EACI,uBAAA;AADR;AAII;EACI,8BAAA;EACA,6BAAA;AAFR;AAKI;EACI,2BAAA;EACA,6BAAA;AAHR;AAMI;EACI,2BAAA;EACA,4BAAA;AAJR;AAOI;EACI,iEAAA;EACA,6BAAA;AALR","sourcesContent":[".map-overlay {\n    position: absolute;\n    top: var(--header-height);\n    left: 380px;\n    bottom: 0;\n    right: 0;\n    pointer-events: none;\n\n    .map-blocker {\n        height: 100%;\n        width: 100%;\n        pointer-events: initial;\n        background-color: rgba(34, 34, 34, 0.3);\n    }\n\n    map-search-bar, select-tour-type, toggle-map-style, waypoint-help {\n        position: absolute;\n    }\n\n    map-search-bar, toggle-map-style, waypoint-help {\n        pointer-events: initial;\n    }\n\n    toggle-map-style {\n        bottom: var(--element-spacing);\n        right: var(--element-spacing);\n    }\n\n    select-tour-type {\n        top: var(--element-spacing);\n        right: var(--element-spacing);\n    }\n\n    map-search-bar {\n        top: var(--element-spacing);\n        left: var(--element-spacing);\n    }\n\n    waypoint-help {\n        top: calc(var(--element-spacing) + 60px + var(--element-spacing));\n        right: var(--element-spacing);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
